/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var react_transition_group_1 = require("react-transition-group");
var OutsideClick_1 = require("./util/OutsideClick");
var GenericTransition_1 = require("./util/GenericTransition");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./CompositeDropdown.css'); }
var ProfilePicture_1 = require("./ProfilePicture");
var Icon_1 = require("./Icon");
var Spinner_1 = require("./Spinner");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-compositeDropdown");
var CompositeDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(CompositeDropdown, _super);
    function CompositeDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleIconClick = _this.handleIconClick.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        return _this;
    }
    CompositeDropdown.prototype.getChildContext = function () {
        return {
            handleOnClose: this.handleIconClick
        };
    };
    CompositeDropdown.prototype.handleIconClick = function (e) {
        e.preventDefault();
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    CompositeDropdown.prototype.handleOutsideClick = function () {
        if (this.props.active && this.props.onRequestClose) {
            this.props.onRequestClose();
        }
    };
    CompositeDropdown.prototype.render = function () {
        var _a = this.props, abbreviation = _a.abbreviation, serviceUnavailable = _a.serviceUnavailable, active = _a.active, className = _a.className, header = _a.header, showSpinner = _a.showSpinner, children = _a.children, color = _a.color, labelChildren = _a.labelChildren, badgeCount = _a.badgeCount, userName = _a.userName, companyName = _a.companyName, mobile = _a.mobile, gender = _a.gender;
        return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.handleOutsideClick },
            React.createElement("div", { className: classnames(moduleClassName(), className, active && moduleClassName("isActive"), mobile && moduleClassName("isMobile")) },
                mobile && (React.createElement("div", { className: moduleClassName("overlay"), onClick: this.handleOutsideClick })),
                React.createElement("div", { className: moduleClassName("trigger"), onClick: this.handleIconClick },
                    React.createElement("div", { className: classnames(moduleClassName("label"), !companyName && moduleClassName("hasNoCompany")) },
                        React.createElement("span", { className: moduleClassName("userName") }, userName),
                        React.createElement(react_transition_group_1.TransitionGroup, null,
                            React.createElement(GenericTransition_1.FadeToBottom, { key: companyName, appear: false, mountOnEnter: true, unmountOnExit: true },
                                React.createElement("span", { className: moduleClassName("companyName") }, companyName))),
                        labelChildren),
                    React.createElement("div", { className: moduleClassName("user") },
                        React.createElement(GenericTransition_1.Fade, { in: showSpinner },
                            React.createElement(Spinner_1.Spinner, { className: moduleClassName("spinner") })),
                        !serviceUnavailable && (React.createElement(GenericTransition_1.FadeScale, { timeout: 2000, in: !showSpinner && !!badgeCount },
                            React.createElement("div", { className: moduleClassName("indicator") },
                                React.createElement("div", { className: moduleClassName("indicatorIcon") })))),
                        React.createElement(GenericTransition_1.FadeScale, { timeout: 2000, in: !showSpinner },
                            React.createElement(ProfilePicture_1.ProfilePicture, { serviceUnavailable: serviceUnavailable, size: "small", abbreviation: abbreviation, gender: gender, color: color, badgeCount: badgeCount, className: classnames(moduleClassName("triggerIcon")) })))),
                React.createElement(react_transition_group_1.CSSTransition, { key: "content", in: active, className: moduleClassName("container"), classNames: moduleClassName("container"), timeout: 300, mountOnEnter: true, unmountOnExit: true },
                    React.createElement("div", null,
                        header,
                        React.createElement("div", { className: moduleClassName("containerScroller") },
                            React.createElement("div", { className: moduleClassName("containerContent") }, children)))))));
    };
    CompositeDropdown.propTypes = {
        serviceUnavailable: PropTypes.bool,
        header: PropTypes.element,
        showSpinner: PropTypes.bool,
        userName: PropTypes.string,
        badgeCount: PropTypes.number,
        companyName: PropTypes.string,
        labelChildren: PropTypes.node,
        abbreviation: PropTypes.node,
        color: ProfilePicture_1.ProfilePicture.propTypes.color,
        gender: ProfilePicture_1.ProfilePicture.propTypes.gender,
        active: PropTypes.bool,
        onClick: PropTypes.func,
        onRequestClose: PropTypes.func,
        className: PropTypes.string
    };
    CompositeDropdown.defaultProps = {
        serviceUnavailable: false,
        mobile: false,
        gender: ProfilePicture_1.ProfilePicture.defaultProps.gender
    };
    CompositeDropdown.childContextTypes = {
        handleOnClose: PropTypes.func
    };
    return CompositeDropdown;
}(React.Component));
exports.CompositeDropdown = CompositeDropdown;
var CompositeDropdownManaged = /** @class */ (function (_super) {
    tslib_1.__extends(CompositeDropdownManaged, _super);
    function CompositeDropdownManaged() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false
        };
        _this.handleClick = function () {
            _this.setState({ active: true });
        };
        _this.handleRequestClose = function () {
            if (_this.props.hidesOnOutsideClick) {
                _this.setState({ active: false });
            }
        };
        return _this;
    }
    CompositeDropdownManaged.prototype.render = function () {
        return (React.createElement(CompositeDropdown, tslib_1.__assign({}, this.props, { onClick: this.handleClick, onRequestClose: this.handleRequestClose, active: this.state.active })));
    };
    CompositeDropdownManaged.propTypes = tslib_1.__assign({}, CompositeDropdown.propTypes, { hidesOnOutsideClick: PropTypes.bool });
    CompositeDropdownManaged.defaultProps = tslib_1.__assign({}, CompositeDropdown.defaultProps, { hidesOnOutsideClick: true });
    return CompositeDropdownManaged;
}(React.Component));
exports.CompositeDropdownManaged = CompositeDropdownManaged;
var CompositeDropdownHeader = /** @class */ (function (_super) {
    tslib_1.__extends(CompositeDropdownHeader, _super);
    function CompositeDropdownHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompositeDropdownHeader.prototype.render = function () {
        var _a = this.props, children = _a.children, handleOnClose = _a.handleOnClose;
        return (React.createElement("div", { className: moduleClassName("header") },
            React.createElement("div", { className: moduleClassName("headerContent") }, children),
            React.createElement("a", { href: "#", onClick: handleOnClose, className: classnames("modal-close", moduleClassName("headerClose")) },
                React.createElement(Icon_1.Icon, { type: "close", color: "white", size: 1.3 }))));
    };
    CompositeDropdownHeader.propTypes = {
        handleOnClose: PropTypes.func
    };
    return CompositeDropdownHeader;
}(React.Component));
exports.CompositeDropdownHeader = CompositeDropdownHeader;